var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{attrs:{"id":"the-end"}},[_vm._v("— "+_vm._s(_vm.$t("end"))+" —")])])}
var staticRenderFns = []

export { render, staticRenderFns }